const INPUT = "w-full mt-1 px-3 py-2.5 rounded-lg border border-slate-200 focus:border-blue-500 focus:ring-2 focus:ring-blue-100 outline-none text-sm";
const LABEL = "text-xs font-semibold uppercase tracking-wider text-slate-500";

export const passwordProblem = (next, confirm) => {
  if (next.length < 8) return "Password must be at least 8 characters";
  if (!/[A-Za-z]/.test(next) || !/\d/.test(next)) return "Use at least one letter and one number";
  if (next !== confirm) return "Passwords don't match";
  return null;
};

export function PasswordFields({ value, onChange, prefix }) {
  const mismatch = value.confirm && value.next !== value.confirm;
  return (
    <div className="space-y-4">
      <div>
        <label className={LABEL}>New password</label>
        <input data-testid={`${prefix}-new-password`} type="password" autoComplete="new-password" value={value.next} onChange={(e) => onChange({ ...value, next: e.target.value })} required className={INPUT} />
        <div className="text-[11px] text-slate-400 mt-1">At least 8 characters, with a letter and a number.</div>
      </div>
      <div>
        <label className={LABEL}>Confirm new password</label>
        <input data-testid={`${prefix}-confirm-password`} type="password" autoComplete="new-password" value={value.confirm} onChange={(e) => onChange({ ...value, confirm: e.target.value })} required className={INPUT} />
        {mismatch && <div className="text-[11px] text-rose-600 mt-1" data-testid={`${prefix}-mismatch`}>Passwords don't match</div>}
      </div>
    </div>
  );
}
